module.exports = __webpack_public_path__ + "static/media/close-sketch.dde61d22.svg";